import {
  persistDiagnosticsEnabled,
  persistSessionFilter,
  persistSidebarWidth,
} from '../../utils/chatPrefs'
import type { ChatStoreCreator, PrefsMutations } from './types'

export const prefsMutations: ChatStoreCreator<PrefsMutations> = (set) => ({
  setDiagnosticsEnabled(enabled: boolean) {
    persistDiagnosticsEnabled(enabled)
    set({ diagnosticsEnabled: enabled })
  },

  // Persistence (per-project, in local storage) is handled reactively by
  // `useHydrateSidebarCollapsed` rather than here, so every code path that
  // expands or collapses the panel is remembered without each call site
  // needing the project slug.
  setSidebarCollapsed(collapsed: boolean) {
    set({ sidebarCollapsed: collapsed })
  },

  setSidebarWidth(width: number) {
    persistSidebarWidth(width)
    set({ sidebarWidth: width })
  },

  // Not persisted — fullscreen is a transient focus mode, not a remembered
  // preference. A user landing on the page with chat already taking over
  // the whole viewport from a previous session would be surprising.
  setSidebarFullScreen(fullScreen: boolean) {
    set({ sidebarFullScreen: fullScreen })
  },

  // Not persisted — transient UI state lifted into the store so the
  // collapsed-rail's history shortcut can both expand the panel and
  // open the conversation history popover in one click.
  setHistoryPopoverOpen(open: boolean) {
    set({ historyPopoverOpen: open })
  },

  // Persisted: the Mine/Team/All choice is a sticky preference, so the user
  // lands on the same slice of the shared chats next time.
  setSessionFilter(filter) {
    persistSessionFilter(filter)
    set({ sessionFilter: filter })
  },

  // Not persisted — search is a transient, in-the-moment narrowing.
  setSessionSearch(query: string) {
    set({ sessionSearch: query })
  },

  // Plain state setter; persistence (keyed by user) lives in `useChatIntro`,
  // which has the current user id. Used both to hydrate and to dismiss.
  setChatIntroDismissed(dismissed: boolean) {
    set({ chatIntroDismissed: dismissed })
  },
})
